<div class="table-toolbar d-flex align-items-center">
  <ng-content></ng-content>
</div>
